module.exports = __webpack_public_path__ + "img/my-story-charming-hotel-augusta.7d31f7d1.jpg";